<template>
  <div class="container is-fluid is-mobile has-text-centered">
    <div class="hero-video is-fullheight">
      <video v-if="!token" autoplay is-responsive muted loop id="myVideo">
        <source src="@/assets/BW-Scroll.mp4" type="video/mp4" />
      </video>
    </div>
    
<section class="hero  is-fullheight">
  <div class="hero-body">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-5-tablet is-12-mobile is-4-desktop is-4-widescreen is-responsive">
          <form action="" class="box">
              <div class="card-image">
              <div style="margin-top: 20px">
                <img src="@/assets/logo.png" alt="Vagalume" width="144px" />
              </div>
            </div>
            <div class="field">

              <div class="control has-icons-left">
              <b-field label="Username" >
                <b-input v-model="username"></b-input>
              </b-field>
              </div>
            </div>
            <div class="field">
              <div class="control has-icons-left">
              <b-field label="Password" >
                <b-input v-model="password" type="password"></b-input>
              </b-field>
              </div>
            </div>

            <div class="field">
 <b-button  class="is-primary" :loading="isLoading" @click.native="logIn">Entrar</b-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Webservices from "@/Webservices";

const ws = new Webservices();

export default {
  props: {
    token: String
  },
  data() {
    return {
      hasLoginError: false,
      isPwsVisible: false,
      isLoading: false,
      username: "",
      password: "",
      logged: false
    };
  },
  mounted() {
    if (this.token) {
      localStorage.setItem("auth_token", this.token);

      var credentials = this.$jwt.decode();

      this.username = credentials.username;
      this.password = credentials.password;

      this.logIn();
    } else {
      console.log("Sem token");
    }
  },
  computed: {
    ...mapGetters(["isLoggedIn", "isADM", "getGroupId"])
  },
  methods: {
    ...mapActions(["login", "loggedIn", "setClientsList", "selectClient"]),
    logIn() {
      this.isLoading = true;
      ws.login([this.username, this.password])
        .then(response => {
          var loginData = response.data;

          this.login(loginData);

          return ws.getUserById(loginData.userId);
        })
        .catch(err => {})
        .then(response => {
          var userData = response.data;

          this.loggedIn(userData);
          if (userData.group && userData.group.id) {
            ws.getClientsCharts(userData.group.id)
              .then(response2 => {
                this.setClientsList(response2.data);
              })
              .catch(error2 => {});
          } else {
            ws.getClientById(userData.client.id, [
              "radio_prefix",
              "controller_id",
              "name",
              "id"
            ]).then(response2 => {
              this.selectClient(response2.data);
            });
          }
        })
        .catch(err => {
          //TRATAR ALERT AQUI
          this.username = ""
          this.password = ""
          alert("Credenciais Incorretas")
          this.isLoading = false;
        });
    }
  },
  watch: {
    isLoggedIn(newValue, oldValue) {
      if (newValue) {
        this.isLoading = false;
        this.$router.push("/dashboard");
      }
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=K2D");

* {
  font-family: "K2D", "Arial";
}

#myVideo {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
}
.loginButon {
  text-align: center;
  border-bottom: 10p;
  right: 60%;
  bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login2.vue